import Vue from "vue";

function addZero(num) {
  return num < 10 ? `0${num}` : num;
}
/**
 * @desc 课程卡片秒数格式化【转换成分秒】
 * @param {string} seconds 秒数
 */
function courseSecondsFormat(seconds) {
  if (!seconds) return "00:00";
  // const hours = parseInt(seconds / 3600);
  // const mins = Math.ceil((seconds % 3600) / 60); // 不足一分的取一分钟
  const mins = parseInt(seconds / 60);
  const secs = seconds % 60;
  return `${addZero(mins)}:${addZero(secs)}`;
}

/**
 * @desc 时间戳转换成年月日时分秒
 * @param {string} timestamp 秒数
 */
function timestampToYMDHMS(timestamp) {
  if (!timestamp) return "-";
  const date = new Date(Number(timestamp));
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return `${year}-${addZero(month)}-${addZero(day)} ${addZero(hour)}:${addZero(
    minute
  )}:${addZero(second)}`;
}

Vue.filter("courseSecondsFormat", courseSecondsFormat);
Vue.filter("timestampToYMDHMS", timestampToYMDHMS);



// WEBPACK FOOTER //
// ./src/gtn/utils/filters.js